import Styled from 'styled-components';

export const ToastWrapper = Styled.div`
    width: 290px;
    min-height:90px; 
    border-radius: 4px;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #e6e6e6;
    background-color: #ffffff;
    padding:16px;
    font-size: 12px;
    color: #535353;
    box-sizing: border-box; 
    margin-bottom:10px;
`;
